module.exports = __webpack_public_path__ + "img/L.bd7d6891.svg";